/**
 * Calcula o Valor Futuro (equivalente à função VF do Excel)
 * Giovani 09/01/2026
 * @param {number} taxa  - Taxa de juros por período (ex: 0.01 = 1%)
 * @param {number} nper  - Número de períodos
 * @param {number} pgto  - Pagamento periódico (use negativo para investimentos)
 * @param {number} vp    - Valor presente (opcional, padrão = 0)
 * @param {number} tipo  - 0 = pagamento no fim do período | 1 = no início
 *
 * @returns {number} Valor futuro
 */

export function VF(taxa, nper, pgto, vp = 0, tipo = 0) {
  if (taxa === 0) {
    return -(vp + pgto * nper);
  }

  const fator = Math.pow(1 + taxa, nper);

  return -(vp * fator + (pgto * (1 + taxa * tipo) * (fator - 1)) / taxa);
}
